import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import { MOCK_BADGES_RESPONSE } from '../badge-mocks';
import { type BadgesResponse } from '../badges';

/**
 * Fetch the student's badges. The shared axios client supplies the base URL
 * (`env.API_URL`) and the auth cookie (`withCredentials`), so only the path is
 * needed here.
 */
export const getBadges = (): Promise<BadgesResponse> =>
  axios.get('/user/v1/badges');

/** MSW handler used in dev/Storybook/tests — returns the sample response. */
export const badgesMockHandler = http.get(
  `${env.API_URL}/user/v1/badges`,
  async (): Promise<HttpResponse<BadgesResponse>> => {
    await networkDelay();
    return HttpResponse.json(MOCK_BADGES_RESPONSE);
  }
);
